<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="student.urlProfilePhoto"
    >
      <template v-slot:header>
        {{$t('notifications.lessonCancelled')}}
      </template>
      <template v-slot:actions>
        <div>
          {{$t('notifications.lessonWithStudent')}}
          <router-link :to="`/students/${student.slug}`" class="font-medium">
            {{ student.name }}
          </router-link>
          {{$t('notifications.cancelled')}}
        </div>
        <button class="flex rounded-sm p-2 text-orange-academy-300 mt-2 uppercase
          border opacity-60 hover:opacity-100 border-orange-academy-300 items-center"
          @click="contact(user, student.user)"
          >
            <message-icon class="w-5"/>
            <span class="pl-3">
            {{$t('notifications.sendMessage')}} {{ student.name }}
            </span>
        </button>
      </template>
    </notification-template>
    <div class="flex flex-col bg-gray-300 p-2 rounded mt-6 justify-between w-2/3 ml-20"
      v-show="large">
      <div class="flex justify-between pl-2 pb-2">
        <p class="uppercase"> {{student.name}} </p>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="opacity-30 w-3 flex self-end"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 96C42.98 96 0 138.1 0 192s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192C192 138.1 149 96 96 96zM448 192c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192z"/></svg>
      </div>
      <p class="pl-8 italic">{{ lesson.comments }}</p>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="opacity-30 w-3 flex mt-2"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 224C84.72 224 74.05 226.3 64 229.9V224c0-35.3 28.7-64 64-64c17.67 0 32-14.33 32-32S145.7 96 128 96C57.42 96 0 153.4 0 224v96c0 53.02 42.98 96 96 96s96-42.98 96-96S149 224 96 224zM352 224c-11.28 0-21.95 2.305-32 5.879V224c0-35.3 28.7-64 64-64c17.67 0 32-14.33 32-32s-14.33-32-32-32c-70.58 0-128 57.42-128 128v96c0 53.02 42.98 96 96 96s96-42.98 96-96S405 224 352 224z"/></svg>
    </div>
  </div>
</template>

<script>
import NotificationTemplate from './NotificationTemplate.vue';
import MessageIcon from '../graphics/MessageIcon.vue';
import StreamFunctionsMixin from '../../mixins/StreamFunctionsMixin';

export default {
  components: {
    MessageIcon,
    NotificationTemplate,
  },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lesson: { ...this.notification.data.lesson },
      student: { ...this.notification.data.student },
      slot: { ...this.notification.data.slot },
    };
  },
  mixins: [StreamFunctionsMixin],
};
</script>
